class AvailOffers extends HTMLElement{
  constructor(){
    super();
    this.externalFxns()
  }
  externalFxns(){
    const offers = this.querySelectorAll('.JPS_AvailOffer');
    for(let i=0; i< offers.length; i++){if(offers[i]){offers[i].addEventListener('click',this.toggler.bind(offers[i]))}}
  }
  toggler(event){
    event.preventDefault();
    this.classList.add('active_offer'); var node = this.parentNode.firstChild;
    while(node){ if(node !== this && node.nodeType === Node.ELEMENT_NODE ) node.classList.remove('active_offer'); node = node.nextElementSibling || node.nextSibling; }
  }
}
customElements.define('avail-offers', AvailOffers)